<div class="modal-header">
	<h5 class="modal-title text-center">{{ 'orderStateDialog.title' | translate }}</h5>
	<button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="close(false, null)">
		<cfe-icon [iconName]="'close'"></cfe-icon>
	</button>
</div>
<div class="modal-body">
	<p class="modal-comment-header">{{ 'orderStateDialog.text' | translate }}</p>
	<textarea rows="8" maxlength="2000" class="form-control" [(ngModel)]="comment"></textarea>
</div>
<div class="modal-footer">
	<button type="button" class="btn btn-primary" (click)="close(true, OrderState.ACCEPTED)">
		{{ 'orderStateDialog.button.accept' | translate }}
	</button>
	<button type="button" class="btn btn-primary" (click)="close(true, OrderState.DECLINED)">
		{{ 'orderStateDialog.button.decline' | translate }}
	</button>
</div>
